import gql from 'graphql-tag';

export default gql`
  mutation ($contentId: MongoID!, $surveyQuestions: [JSON]!) {
    updateSurveyQuestionsAndReset(contentId: $contentId, surveyQuestions: $surveyQuestions) {
      contentId
      resetProgressCount
      resetSubmissionCount
    }
  }
`;
